// eslint-disable-next-line
// @ts-nocheck
import validateBrowserCertified from './validateBrowserCertified';
import disabledCookiesDialog from './disabledCookies';
import getTimeZoneName from './getTimeZoneName';
import login from './login';

/* Custom 2024-12-24: jake.9; 웹 브라우저 창이 닫힐 때 비동기 함수 대신에 동기 함수를 호출하도록 수정 */
const getUnlockItemsXml = function () {
	const dirtyItems = aras.itemsCache.getItemsByXPath(
		`/Innovator/Items/Item | //Item[@isEditState="1" or locked_by_id='${aras.getUserID()}']`
	);

	if (!dirtyItems.length) {
		return '';
	}

	const processedItems = new Set();
	const unlockItemsXml = dirtyItems.reduce((acc, item) => {
		const itemId = item.id;
		if (processedItems.has(itemId)) {
			return acc;
		}

		processedItems.add(itemId);
		const itemType = item.getAttribute('type');
		if (
			aras.isLockedByUser(item) &&
			!ArasModules.item.isNew(itemType, itemId)
		) {
			acc += `<Item type="${itemType}" id="${itemId}" action="unlock"/>`;
		}

		return acc;
	}, '');

	return unlockItemsXml;
};

const logout = function () {
	let asyncLogoffRequestResult;
	aras.setCommonPropertyValue('ignoreSessionTimeoutInSoapSend', true);

	if (aras.getUserID()) {
		const logoutItemRequestXml =
			'' +
			'<Item type="Method" action="LogOff">' +
			getUnlockItemsXml() +
			aras.getUpdatedSavedSearchesXml() +
			aras.getUpdatedPreferenceItemsXml() +
			'</Item>';
		if (aras.Browser.isKeepaliveOptionSupported()) {
			const isContentSizeLessThan64Kb =
				new Blob([logoutItemRequestXml]).size < 1024 * 64;
			asyncLogoffRequestResult = window.fetch(aras.getServerURL(), {
				headers: {
					...aras.getHttpHeadersForSoapMessage('ApplyMethod'),
					'Content-Type': 'application/xml'
				},
				credentials: 'include',
				body: logoutItemRequestXml,
				// Also accordiong to fetch specification(https://fetch.spec.whatwg.org/) browsers should
				// throw error on fetch request with keepalive option when body size is larger than 64kb,
				// so in case when there was a lot of preferences and auto saved search changes
				// request size becomes larger than 64kb and request fails.
				// As a hot fix for I-011663 keepalive is set to false on large requests in order to avoid
				// errors but it is required to minify request size in future and get rid of this fix
				keepalive: isContentSizeLessThan64Kb,
				method: 'POST',
				mode: 'cors'
			});
		} else {
			aras.soapSend('ApplyMethod', logoutItemRequestXml);
		}

		aras.commonProperties.userID = null;
		aras.commonProperties.login;
		aras.commonProperties.loginName = '';
		aras.commonProperties.password = '';
		aras.commonProperties.database = '';
		aras.commonProperties.identityList = '';
	}
	aras.setCommonPropertyValue('ignoreSessionTimeoutInSoapSend', undefined);

	return asyncLogoffRequestResult || Promise.resolve();
};
/* End of Custom */

function onBeforeUnloadHandler() {
	const tabsContainer = window.mainLayout && window.mainLayout.tabsContainer;

	if (aras.getCommonPropertyValue('exitInProgress') === true) {
		return;
	}

	if (aras.isDirtyItems()) {
		window.onLogoutCommand();
		return 'Changes you made may not be saved.';
	} else if (
		tabsContainer &&
		tabsContainer.isExistAnyTabs() &&
		aras.getCommonPropertyValue('exitWithoutSavingInProgress') !== true
	) {
		return 'Changes you made may not be saved.';
	}
}
async function onLoadHandler() {
	if (!navigator.cookieEnabled) {
		await disabledCookiesDialog();
	}

	await validateBrowserCertified();

	try {
		const timeZoneName = await getTimeZoneName();
		aras.setCommonPropertyValue('systemInfo_CurrentTimeZoneName', timeZoneName);
		await login();
	} catch (e) {
		aras.AlertError(e.message);
	}
	aras.setWindowLangAttribute(window);
}
/* Fix 2026-07-16: jake.9; 웹 브라우저의 unload 이벤트 지원 중단를 완화하기 위해 pagehide 이벤트로 대체 */
function onUnloadHandler(event) {
	if (event?.persisted) return;
	if (!window.aras) {
		return;
	}
	aras.setCommonPropertyValue('exitInProgress', true);
	aras.getOpenedWindowsCount(true);

	const { mainLayout } = window;
	if (mainLayout && mainLayout.tabsContainer) {
		const { dockHeaderTabs, undockHeaderTabs } = mainLayout.tabsContainer;
		dockHeaderTabs.forceCloseAllTabs();
		undockHeaderTabs.forceCloseAllTabs();
	}

	/* Custom 2024-12-24: jake.9; 웹 브라우저 창이 닫힐 때 비동기 함수 대신에 동기 함수를 호출하도록 수정 */
	// aras.logout();
	logout();
	/* End of Custom */
}
/* End of Fix */

export default { onBeforeUnloadHandler, onLoadHandler, onUnloadHandler };
